
import Button from '@material-ui/core/Button';
import {ReactNode} from "react";
import {Principal} from "@betrue/shared/interfaces";

export const LoginLogoutView = (
  {
    login,
    logout,
    loginLabel,
    logoutLabel,
    authenticated,
    children,
    principal
  }: {
    login: () => void,
    logout: () => void,
    loginLabel: string,
    logoutLabel: string,
    authenticated: boolean,
    children?: ReactNode,
    principal:Principal

  }) => {


  return <>
    {!authenticated && (
      <Button variant="outlined" onClick={(e) => login()}>{loginLabel}</Button>
    )}
    {authenticated && (
      <><Button variant="outlined"  type="button" onClick={() => logout()}>
        {logoutLabel}
      </Button>
      </>
    )}
    {children}
  </>
}
